import React from "react";
import ConstructionIcon from "@mui/icons-material/Construction";

const Emociones = () => {
  return (
    <div className="flex flex-col items-center justify-center mt-20">
      <ConstructionIcon style={{ fontSize: 200 }} />
      <h1 className="mt-4 text-3xl font-bold">
        Esta vista está en construcción
      </h1>
    </div>
  );
};

export default Emociones;
